var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{class:['q-tag', _vm.colorClass()[1]]},[_vm._v(_vm._s(_vm.colorClass()[0]))])
}
var staticRenderFns = []

export { render, staticRenderFns }